export const VoteMechanismNameLabel: Record<string, string> = {
  TOKEN_BALLOT: '1 token = 1 vote',
  UNIQUE_VOTE: '1 address = 1 vote',
};

export const HighCouncilName = 'HighCouncil';
export const ReferendumName = 'Referendum';
export const Organization = 'Organization';

export enum TIME_OPTIONS {
  Now = 1,
  Specific = 2,
}
